// TODO LEGACY DEPRECATION: Can remove this entire file

// Third-party
import React from 'react';

// Utils
import { truncateString } from '../../../../../utils/objects';
import { FormattedMessage, formatMessage } from '../../../../../utils/i18n';
import { ACTIVITY_FORMAT } from '../../../../../utils/activity-log';

// Components
import { ActivityList } from '../../../../components/activity-log';
import GenericContact from '@/types/generic-contact';
import Activity from '@/types/activity';

type Props = {
  contact: GenericContact;
  activityLogs: Activity[];
  loading: boolean;
  hasMoreLogs: boolean;
  onLoadMore: () => void;
};

export default function ContactActivityLogs(props: Props) {
  const { contact, activityLogs, loading, hasMoreLogs, onLoadMore } = props;

  return (
    <div className="contact-activity-log">
      <div className="content-header">
        <h1>
          <FormattedMessage id="Contacts.ContactTabs.ActivityLogs.Header" values={{ name: truncateString(contact.fname || '', 80) }} />
        </h1>
      </div>

      <ActivityList
        activityLogs={activityLogs}
        loading={loading}
        format={ACTIVITY_FORMAT.CONTACT}
        hasMore={hasMoreLogs}
        onLoadMoreActivity={onLoadMore}
        inline
        emptyStateText={formatMessage('EmptyState.NoContactActivityLog')}
        loadingStateText={formatMessage('Contacts.ContactTabs.ActivityLogs.LoadingActivityLog')}
        scrollAncestor=".app-scrollbar-container"
      />
    </div>
  );
}
